import React from 'react';
import { cn } from '../lib/utils';

// StockMethod bull brand mark (transparent PNG in /public).
export function LogoMark({ size = 36, className }) {
  return (
    <img
      src="/logo-bull.png"
      alt="StockMethod"
      width={size}
      height={size}
      className={cn('object-contain', className)}
      data-testid="logo-mark"
    />
  );
}

export function Logo({ size = 36, className, textClassName }) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <LogoMark size={size} />
      <span className={cn('font-heading text-lg font-semibold leading-none text-white', textClassName)}>
        Stock<span className="text-emerald">Method</span>
      </span>
    </span>
  );
}
